import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { LIST_CHANNEL_OPTION, LIST_CHANNEL_USER_OPTION } from "helpers/constans";
import { getPlatFormImage } from "helpers/format";

interface Option {
  label: string;
  value: string;
}
interface DropdownChannelProps {
  name?: string,
  initialValue?: Option | any | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean,
  className?: string,
  classNamePrefix?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
  colors?: any,
  isClearable?: boolean
}

const DropdownChannel = ({
  name = '',
  initialValue,
  onChangeSelect,
  placeholder,
  disabled = false,
  className = '',
  classNamePrefix = '',
  isHasOptionAll = false,
  optionAll,
  isClearable
}: DropdownChannelProps) => {
  const { t } = useTranslation();

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  const LIST_CHANNEL_OPTION_LANG = LIST_CHANNEL_USER_OPTION?.map((item: any) => ({
    value: item?.value,
    label: (item?.label),
  })) || [];

  const resultOption: any = isHasOptionAll ? [optionAll].concat(LIST_CHANNEL_OPTION_LANG) : LIST_CHANNEL_OPTION_LANG;
  
  return (
    <React.Fragment>
      <Select
        options={resultOption}
        value={(initialValue || isHasOptionAll) ? resultOption.find((item: any) => item.value === initialValue) : null}
        name={name}
        isDisabled={disabled}
        isClearable={isClearable}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        formatOptionLabel={(option: any) => { 
          let imgPlatform = getPlatFormImage(option?.value);
          
          return (
            <div className="d-flex align-items-center">
              {
                imgPlatform ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgPlatform ? <img src={imgPlatform} width={20} height={20} alt="platform" /> : 
                      <span className={`bg-secondary`} style={{ width: "20px", height: '20px', borderRadius: '3px' }}></span>
                    }
                  </div>
                ): ''
              }
              <div>
                {t(option?.label)}
              </div>
            </div>
          )}
        }
        className={className}
        classNamePrefix={classNamePrefix}
        styles={{
          option: (styles: any) => {
            let styleNew = {
              ...styles,
              zIndex: 99,
            };
  
            return styleNew;
          },
          control: (styles: any, { isFocused }: any) => {
            return {
              ...styles,
              borderColor: "#e9ebec",
              borderRadius: "0.6rem",
              color: "white",
              "&:hover": { borderColor: "#009ef7" },
            };
          },
          multiValue: (styles: any) => {
            return {
              ...styles,
              backgroundColor: "#009ef7",
            };
          },
          multiValueLabel: (styles: any) => ({
            ...styles,
            color: "white !important",
          }),
          menuPortal: (base: any) => ({
            ...base,
            zIndex: 1051,
          }),
        }}
      />
    </React.Fragment>
  );
};

export default DropdownChannel;
